/**
 * @generated SignedSource<<d55a48ee57d233fe42dcdcabbc4c698c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type WidgetTeamScheduleInlineRoutineListItemMutation$variables = {
  employeeId?: string | null;
  taskExecutionId: string;
  value?: TaskSentiment | null;
};
export type WidgetTeamScheduleInlineRoutineListItemMutation$data = {
  readonly setTaskExecutionCheck: {
    readonly checkValue: TaskSentiment | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly routineOccasion: {
      readonly status: RoutineOccasionStatus;
    };
  };
};
export type WidgetTeamScheduleInlineRoutineListItemMutation$rawResponse = {
  readonly setTaskExecutionCheck: {
    readonly checkValue: TaskSentiment | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly routineOccasion: {
      readonly id: string;
      readonly status: RoutineOccasionStatus;
    };
  };
};
export type WidgetTeamScheduleInlineRoutineListItemMutation = {
  rawResponse: WidgetTeamScheduleInlineRoutineListItemMutation$rawResponse;
  response: WidgetTeamScheduleInlineRoutineListItemMutation$data;
  variables: WidgetTeamScheduleInlineRoutineListItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskExecutionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "taskExecutionId"
  },
  {
    "kind": "Variable",
    "name": "sentiment",
    "variableName": "value"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTeamScheduleInlineRoutineListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TaskExecutionCheck",
        "kind": "LinkedField",
        "name": "setTaskExecutionCheck",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "routineOccasion",
            "plural": false,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetTeamScheduleInlineRoutineListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TaskExecutionCheck",
        "kind": "LinkedField",
        "name": "setTaskExecutionCheck",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "routineOccasion",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2fa5d95f6198c7fae95fb32122f8d8b7",
    "id": null,
    "metadata": {},
    "name": "WidgetTeamScheduleInlineRoutineListItemMutation",
    "operationKind": "mutation",
    "text": "mutation WidgetTeamScheduleInlineRoutineListItemMutation(\n  $taskExecutionId: ID!\n  $value: TaskSentiment\n  $employeeId: ID\n) {\n  setTaskExecutionCheck(id: $taskExecutionId, sentiment: $value, employeeId: $employeeId) {\n    id\n    checkValue\n    isCompleted\n    routineOccasion {\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3c54b6d6c8ac6f67f1608e6f48f26ba";

export default node;
